import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    padding: "50px 0px",
    width: "80%",
    margin: "auto",

    [theme.breakpoints.down("xl")]: {
      padding: "40px 0px",
      width: "90%",
      position: "relative",
    },

    [theme.breakpoints.down("md")]: {
      padding: "75px 0px",
      width: "100%",
    },

    "& h2": {
      fontWeight: "400",
      fontSize: "20px",
      color: theme.palette.text.light,
      margin: "20px 50px",

      [theme.breakpoints.down("xl")]: {
        fontSize: "22px",
        margin: "20px 0px",
      },

      "& a": {
        color: theme.palette.primary.main,
        textDecoration: "none",
      },
    },

    "& p": {
      fontWeight: "300",
      fontSize: "14px",
      color: theme.palette.text.main,
      margin: "20px 30px",
      fontFamily: "SFMono",

      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
    },
    "& .strength-card": {
      margin: "0px 30px",
      padding: "20px 0px",
      backgroundColor: theme.palette.card.main,
      borderRadius: "15px",

      [theme.breakpoints.down("md")]: {
        margin: "0px 5px",
      },

      "& .strength-gift": {
        [theme.breakpoints.down("md")]: {
          width: "55px",
          height: "55px",
        },
      },
    },
    "& .tool-card": {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
      gap: "5px",
      textAlign: "center",
      margin: "0px 30px",
      marginBottom: "50px",
      paddingTop: "20px",
      backgroundColor: theme.palette.card.main,
      borderRadius: "15px",

      [theme.breakpoints.down("xl")]: {
        gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
        gap: "5px",
      },
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
        gap: "4px",
        margin: "0px 5px",
      },

      "& img": {
        transition: "all 0.2s",
        cursor: "pointer",

        [theme.breakpoints.down("xl")]: {
          width: "35px",
        },
        [theme.breakpoints.down("md")]: {
          width: "30px",
        },

        "&:hover": {
          transform: "translateY(-4px)",

        },
      },

      "& h3": {
        fontWeight: "400",
        fontSize: "16px",
        color: theme.palette.text.light,

        [theme.breakpoints.down("xl")]: {
          fontSize: "16px",
        },
      }
    }

  },

}));
